// extracted by mini-css-extract-plugin
module.exports = {"root":"OykjB","header":"_2T8om","intro":"_2RAL-"};